import React, { useContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import { deepCopy } from "../../utils";
import CreateMsbModal from "./modals/msb/CreateMsbModal";
import CreateSectorModal from "./modals/sectors/CreateSectorModal";
import CreateLocationModal from "./modals/location/CreateLocationModal";
//import CreateDeviceTypeModal from "./modals/device-type/CreateDeviceTypeModal";
import CreateComplianceModal from "./modals/compliance/CreateComplianceModal";
import EditMsbModal from "./modals/msb/EditMsbModal";
import EditSectorModal from "./modals/sectors/EditSectorModal";
import EditLocationModal from "./modals/location/EditLocationModal";
import EditDeviceTypeModal from "./modals/device-type/EditDeviceTypeModal";
import EditComplianceModal from "./modals/compliance/EditComplianceModal";
import EditGroupModal from "./modals/groups/EditGroupModal";
import TargetTypeButton from "../add-rules/target-type/TargetTypeButton";
import { EditTargetTypeModal } from "../add-rules/target-type/EditTargetTypeModal";
import { RemoveTargetTypeModal } from "../add-rules/target-type/RemoveTargetTypeModal";
import { ModalManager } from "./modals/ModalManager";
import { PopupContext } from "../../index";
import * as ruleService from "../ruleService";
import { loadTargetTypesToRedux, setTargetTypesLoading } from "./msbPageService";
import CreateGroupModal from "./modals/groups/CreateGroupModal";


export const TargetTypes = {
    DEVICE_TYPE: "Device Type",
    LOCATION: "Location",
    COMPLIANCE: "Compliance",
    SECTORS: "Sector",
    MSB: "MSB",
    GROUP: "Group"
}

export const ModalTypes = {
    CREATE: "Add",
    SELECT: "Select",
    EDIT: "Edit",
    REMOVE: "Remove"
}

const CreateModals = {
    [TargetTypes.MSB]: CreateMsbModal,
    [TargetTypes.SECTORS]: CreateSectorModal,
    [TargetTypes.LOCATION]: CreateLocationModal,
    //[TargetTypes.DEVICE_TYPE]: CreateDeviceTypeModal,
    [TargetTypes.COMPLIANCE]: CreateComplianceModal,
    [TargetTypes.GROUP]: CreateGroupModal
}

const EditModals = {
    [TargetTypes.MSB]: EditMsbModal,
    [TargetTypes.SECTORS]: EditSectorModal,
    [TargetTypes.LOCATION]: EditLocationModal,
    [TargetTypes.DEVICE_TYPE]: EditDeviceTypeModal,
    [TargetTypes.COMPLIANCE]: EditComplianceModal,
    [TargetTypes.GROUP]: EditGroupModal
    //[TargetTypes.GROUP]: EditTargetTypeModal
}

function renderModal(targetType, modalType, props) {

    let Modal;

    switch (modalType) {
        case ModalTypes.CREATE:
            Modal = CreateModals[targetType]
            break;
        case ModalTypes.SELECT:
            Modal = EditTargetTypeModal
            break;
        case ModalTypes.EDIT:
            Modal = EditModals[targetType]
            break;
        case ModalTypes.REMOVE:
            Modal = RemoveTargetTypeModal
            break;
        default:
            Modal = EditTargetTypeModal;

    }

    return Modal ? <Modal {...props} /> : null;
}


function TargetTypeManagement({ targetTypes, userCapability, currentUserRole }) {

    const { setPopup } = useContext(PopupContext);
    const isAdmin = String(currentUserRole || "").toLowerCase() === "admin";

    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [modalProps, setModalProps] = useState({});
    const [targetType, setTargetType] = useState(null);

    const targetTypeElements = deepCopy(targetTypes);

    //#region Set User Capabilities
    const [addTargetCapability, setAddTargetCapability] = useState(-1);
    const [editTargetCapability, setEditTargetCapability] = useState(-1);
    const [removeTargetCapability, setRemoveTargetCapability] = useState(-1);
    useEffect(() => {
        if (userCapability) {
            const addTargetPermission = userCapability.find(item =>
                item.component === "addtarget" && item.type === "field")?.permission;
            setAddTargetCapability(addTargetPermission);

            const editTargetPermission = userCapability.find(item =>
                item.component === "edittarget" && item.type === "field")?.permission;
            setEditTargetCapability(editTargetPermission);

            const removeTargetPermission = userCapability.find(item =>
                item.component === "removetarget" && item.type === "field")?.permission;
            setRemoveTargetCapability(removeTargetPermission);
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion

    useEffect(() => {
        if (!showModal) {
            setTargetType(null);
            setModalType(null);
            setModalProps({});
            setTargetTypesLoading(true);
            ruleService.loadRuleTargetTypes({ includeAllMsbs: isAdmin, skipNavigationFilters: true })
                .then((data) => {
                    loadTargetTypesToRedux(data);
                    return ruleService.loadRuleTargetTypes({ includeAllMsbs: isAdmin, silentLoading: true });
                })
                .then((data) => loadTargetTypesToRedux(data))
                .catch(() => setTargetTypesLoading(false));
        }
    }, [showModal, isAdmin])

    const openTargetTypeSelector = (modalType) => {
        //const elements = Object.values(TargetTypes).map(tt => ({ id: tt, name: tt }));

        const elements = Object.values(TargetTypes)
            .filter(tt => tt !== 'Device Type')
            .map(tt => ({ id: tt, name: tt }));

        setTargetType(null);
        setModalType(null);

        setModalProps({
            title: `${modalType} Target Type`,
            text: 'Select Target Type',
            elements: elements,
            onClick: (tType) => showTargetTypeModal(tType.id, modalType)
        });
        setShowModal(true);
    }

    function showTargetTypeModal(tType, modalType) {
        setTargetType(tType);
        const modalManager = new ModalManager(
            tType,
            setModalProps,
            setModalType,
            setShowModal,
            setPopup,
            targetTypeElements
        );
        modalManager.showModal(modalType);

    }

    const backActionType = modalType === ModalTypes.SELECT
        ? ModalTypes.EDIT
        : modalType === ModalTypes.CREATE
            ? ModalTypes.CREATE
        : modalType === ModalTypes.REMOVE
            ? ModalTypes.REMOVE
            : null;

    const backModalProps = backActionType
        ? { onBack: () => openTargetTypeSelector(backActionType) }
        : {};

    return (<>
        <div className="target-type-modal">
            {showModal && renderModal(targetType, modalType, { setShowModal, ...modalProps, ...backModalProps })}
        </div>
        <div className="d-flex justify-content-center bg-white">
            <TargetTypeButton onClick={() => openTargetTypeSelector(ModalTypes.CREATE)}
                name={'Add'}
                className={'mr-2'}
                disabled={addTargetCapability === 0 ? true : false} />
            <TargetTypeButton onClick={() => openTargetTypeSelector(ModalTypes.EDIT)}
                name={'Edit'}
                className={'mr-2'}
                disabled={editTargetCapability === 0 ? true : false} />
            <TargetTypeButton onClick={() => openTargetTypeSelector(ModalTypes.REMOVE)}
                name={'Remove'}
                className="outline"
                disabled={removeTargetCapability === 0 ? true : false} />
        </div>
    </>)

}


function mapStateToProps(state) {
    const auth = state.auth;
    return {
        targetTypes: state.msbPage.targetTypes || {},
        currentUserRole: auth.userRole?.name,
        userCapability: auth.userCapability,
    }
}

export default connect(mapStateToProps)(TargetTypeManagement);
